import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Prev_Btn from "../common/common-btn/prev-btn/Prev_Btn";
import Next_Btn from "../common/common-btn/next-btn/Next_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import { Context } from "../../utils/context";
import { useForm } from "react-hook-form";

const Pickup_Modal = ({ show, handleClose, getBooking, handleUpdate }) => {

  const {
    register, control, reset,
    handleSubmit, watch, setValue,
    formState: { errors },
  } = useForm();
  const {
    IMG_URL,
    Select2Data,
    getData,
    postData,
    BookingData,
    setBookingData
  } = useContext(Context);




  const handleSave = () => {
    handleClose();
  };


  const resetFormData = async () => {
    await reset({
      pickup_at: BookingData?.pickup_at,
      pickup_location: BookingData?.pickup_location || "",
    })
  }

  useEffect(() => {
    resetFormData()
  }, [show]);


  const onSubmit = async (data) => {
    console.log("Form Data:", data);
    const formData = new FormData();

    formData.append("pickup_location", data?.pickup_location);
    formData.append("pickup_at", data?.pickup_at);

    const response = await postData(`/without-login/booking/step-1/${BookingData?.id}`, formData);
    if (response?.success) {
      // setTimeout(() => {
      await getBooking()
      await handleSave()
      // }, 2500);
    } else {
      // setApiError(response?.errors)
      console.error("Form submission failed:", response?.errors);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="xl"
      className="pickup_modal edit_trip_modal"
    >
      <Modal.Header>
        <Modal.Title>Edit Pick-up Details</Modal.Title>
        <div className="edit_close_btn" onClick={handleClose}>
          <FontAwesomeIcon icon={faXmark} style={{ color: "#FFFFFF" }} />
        </div>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row>
            <Col md={6} sm={6} className="mb-3">
              <Form.Group>
                <Form.Label>Pick-up Time</Form.Label>
                <Form.Control
                  type="time"
                  className="pickup_select"
                  {...register("pickup_at", {
                    required: "Pickup time is required",
                  })}
                />
              </Form.Group>
            </Col>

            {/* <Col md={6} sm={6} className="mb-3">
              <Form.Group>
                <Form.Label>Trip Date</Form.Label>
                <DatePicker
                  selected={selectedDate}
                  onChange={setSelectedDate}
                  placeholderText="Select Date"
                />
              </Form.Group>
            </Col> */}

            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>Pick-up Location</Form.Label>
                <Form.Control
                  type="text"
                  className="pickup_input"
                  {...register("pickup_location", {
                    required: "Location is required",
                    maxLength: {
                      value: 250,
                      message: "Maximum 250 characters allowed",
                    },
                  })}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <div className="both_btn_holder">
          <div onClick={handleClose}>
            <Prev_Btn text="Cancel" />
          </div>
          <div onClick={handleSubmit(onSubmit)}>
            <Next_Btn text="Save Changes" />
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default Pickup_Modal;
